import React, { useEffect } from 'react';
import Contact from '../components/Contact';

import kpi_dashbaording_banner from '../assets/kpi_dashboarding_banner.png'
import kpi_dashbaording from '../assets/kpi_dashboarding.png'

const KPIDashboarding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className='mt-20 relative'>
        <div className='relative mt-[6rem]'>
          <img
            className='w-full h-[40rem] blur-sm object-cover'
            src={kpi_dashbaording_banner}
            alt='KPI Dashboarding at Jyotinay Analytics'
          />
          <div className='container mx-auto absolute inset-0 flex flex-col items-center justify-center px-4 text-center'>
            <p className='text-white text-3xl md:text-5xl font-bold'>
              KPI Dashboarding at Jyotinay Analytics
            </p>
            <p className='text-white text-base md:text-xl mt-4 md:mt-8 max-w-3xl'>
              Visualize performance like never before. Our KPI dashboards deliver real-time, actionable insights to help you stay aligned with your goals.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className='container mx-auto mt-12 px-4'>
        <div className='max-w-3xl mx-auto text-left'>
          <p className='text-base md:text-lg leading-relaxed'>
            At Jyotinay Analytics, we specialize in creating clean, intuitive KPI dashboards that turn
            complex datasets into clear, actionable visualizations. Our dashboards give teams and leadership
            the power to track progress, measure success, and make informed decisions — in real time.
          </p>

          <img
            className='w-full md:w-[30rem] h-[15rem] object-cover mt-8 rounded-lg shadow-md mx-auto'
            src={kpi_dashbaording}
            alt='KPI Dashboards'
          />

          {/* Why KPI Dashboarding Section */}
          <div className='mt-12'>
            <h2 className='text-xl md:text-2xl font-semibold mb-4'>
              Why Your Business Needs a KPI Dashboard
            </h2>

            <p className='mb-4 text-base md:text-lg leading-relaxed'>
              Without the right metrics displayed in the right way, businesses struggle to understand performance.
              KPI dashboards bring data clarity — highlighting wins, exposing risks, and aligning efforts.
            </p>

            <p className='mb-6 text-base md:text-lg leading-relaxed'>
              We design dashboards tailored to your business needs, helping every stakeholder — from analyst
              to executive — stay informed and focused.
            </p>

            <ul className='list-disc ml-6 space-y-2 text-base md:text-lg'>
              <li>Real-time performance tracking across departments</li>
              <li>Custom dashboards for executives, teams, and projects</li>
              <li>Interactive visuals and drill-down capabilities</li>
              <li>Integration with your existing data sources</li>
              <li>Mobile-responsive and user-friendly interfaces</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <Contact />
    </div>
  );
};

export default KPIDashboarding;
